// CeoTeams.jsx
import { Box, Typography, IconButton, colors, useTheme, useMediaQuery, ButtonBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import Divider from "@mui/material/Divider";
import AddCallIcon from "@mui/icons-material/AddCall";
import EmailIcon from "@mui/icons-material/Email";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import Tooltip from "@mui/material/Tooltip";

// get icons
import king from '../../assets/icons/teams/king.png'

const TeamCard = ({ team }) => (
  <Box
    sx={{
      boxShadow: 2,
      p: 1,
      width: "100%",
      height: {xs: 'auto', sm: '480px', md: '480px'},
      borderRadius: "1rem",
      position: "relative",
      minWidth: 0,
      cursor: "pointer",
    }}
    onClick={() => window.location.assign(`/about/profile/?ui=${team.Id}`)}
  >
    <Box position={'relative'} overflow={'hidden'} zIndex={1}>
      <Box
        width={'200px'}
        height={'440px'}
        overflow={'hidden'}
        position={'absolute'}
        top={'-50px'}
        right={'-60px'}
        backgroundColor = {colors.green[100]}
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
        borderRadius={'50%'}
        zIndex={-1}
      >
        <img src={king} alt="king" style={{width: 'auto', height: '100%', zIndex: 2, opacity: .5}} />
      </Box>
      {team.image ? (
        <Box sx={{ width: "100%", height: { xs: '300px', sm: "250px", md: "280px" }, overflow: "hidden" }}>
          <img
            alt={team.FirstName}
            src={`https://mindsinaction.com.na/assets/media/pictures/${team.image}`}
            style={{
              width: "100%",height: '100%', objectFit: 'cover'
            }}
          />
        </Box>
      ) : (
        <Avatar
          sx={{
            width: "150px",
            height: "150px",
            borderRadius: "50%",
            backgroundColor: colors.blue[100],
          }}
        >
          <SupervisorAccountIcon sx={{ fontSize: "10rem" }} />
        </Avatar>
      )}
    </Box>
    <Typography fontWeight={700} fontSize={"1.2rem"} mt={"1rem"}>
      {team.FirstName} {team.LastName}
    </Typography>
    <Typography variant={'body1'} dangerouslySetInnerHTML={{ __html: team.role_explanation }}/>
    <Box
      sx={{
        position: { xs: "relative", sm: "absolute", md: "absolute" },
        width: { xs: "auto", sm: "95%", md: "95%" },
        bottom: "0",
        mt: { xs: "1rem", sm: "0", md: "0" },
      }}
    >
      <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} p={1}>
        <Box display={"flex"} flexDirection={'column'}>

          <Box display={"flex"} alignItems={"center"} gap={1}>
            <Tooltip title={team.email} arrow placement="top">
              <IconButton href={`mailto:${team.email}`}>
                <EmailIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="body2" ml={1}>
              {team.email}
            </Typography>
          </Box>

          <Box display={"flex"} alignItems={"center"}  gap={1}>
            <Tooltip title={`+264${team.Cell}`} arrow placement="top">
              <IconButton href={`tel:+264${team.Cell}`}>
                <AddCallIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="body2" ml={1}>
              +264{team.Cell}
            </Typography>
          </Box>
        </Box>
        <Box display={"flex"} alignItems={"center"} width={'100%'} 
        sx={{
          borderTop:'.1rem solid gray'
        }}>
          <ButtonBase onClick={() => window.location.assign(`/about/profile/?ui=${team.Id}`)} 
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            backgroundColor: colors.lightBlue[800],
            color: 'white',
            padding: '0.5rem 1rem',
            width: '100%',
            borderRadius: '0.5rem',
            mt: 1,
           }}>
            <Typography variant="body2" ml={1}>
              Read Profile
            </Typography>
          </ButtonBase>
        </Box>
      </Box>
    </Box>
  </Box>
);

const CeoTeams = ({ teams = [] }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.down("md"));
  const itemWidth = isXs ? 300 : isSm ? 250 : 280;
  const totalSlides = teams.length;

  if (totalSlides === 0) return null;

  return (
    <Box sx={{ display: "flex", height: "auto", width: "auto", overflowX: "auto", gap: 1, 
    justifyContent: "start", padding: '1rem' }}
    data-aos="zoom-in"
    data-aos-delay="400"
    >

      {/* teams cards */}
      {teams.map((team) => (
        <Box
          key={team.Id}
          sx={{
            flexShrink: 0,
            width: `${itemWidth}px`,
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TeamCard team={team} />
        </Box>
      ))}
    </Box>
  );
};

export default CeoTeams;